import { Component, input, InputSignal } from '@angular/core';
interface bannerContentInput {
  bannerTitle: string, 
  bannerText: string,
  bannerImg: string
  bannerImgMobile: string,
}

@Component({
  selector: 'app-section-banner',
  imports: [],
  templateUrl: './section-banner.html',
  styleUrl: './section-banner.scss',
})
export class SectionBanner {
  bannerContent: InputSignal<bannerContentInput> = input<bannerContentInput>({bannerTitle: 'Título', bannerText: 'lorem ipsum dolor', bannerImg: 'assets/sectors/cards/page-section-card-1.jpg', bannerImgMobile: 'assets/sectors/cards/page-section-card-1-mobile.jpg'})
}
